<template>
	<div class="message">
		<div class="message-text">{{ t('billing.paypal.redirect_to_paypal') }}</div>
	</div>
	<Teleport v-if="isMounted" to="#billing-popup-action">
		<BraintreeClient v-show="isActive" :authorization="braintreeClientApiKey" v-slot="{ client }">
			<PaypalButton @click="onClick" @approve="onApprove" @tokenized="onTokenized" v-if="client" :client="client" />
		</BraintreeClient>
	</Teleport>
</template>

<script setup>
import useLifeCycleState from '@/composition/lifeCycleState'
import { useLoader } from '@/composition/loader'
import { PaypalButton, BraintreeClient } from '@frontend/simple-billing'
import { inject } from '@vue/runtime-core'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

defineProps({
	isActive: {
		type: Boolean,
		default: false
	}
})
const emits = defineEmits(['tokenized'])
const { t } = useI18n()

const store = useStore()
const braintreeClientApiKey = store.getters['env/getProperty']('braintreeClientApiKey')

const { isMounted } = useLifeCycleState()
const loader = useLoader()

const onApprove = () => loader.show()
const onTokenized = (payload) => {
	emits('tokenized', { provider: 'braintree', payment_method_nonce: payload.nonce })
}

const amplitude = inject('amplitude')
const onClick = () => {
	amplitude.logEvent('ButtonClick', {
		title: 'PayPalPayButton',
		path: ['OnboardingPaywall', 'PaymentMethodPopup']
	})
}
</script>

<style lang="scss">
.paypal-buttons {
	display: block !important;
}
.message {
	margin: 10vh auto;
	text-align: center;
	max-width: 90%;
	color: #6a6d82;
}
</style>
